<reb-ngx-chip
  [mood]="mood"
  [statusIndicator]="true"
>
  {{ status }}
</reb-ngx-chip>
